<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="work-group-server-table"
      class="w-100"
    >
      <span slot="name" slot-scope="{ row }">
        <router-link :to="`/workgroups/${row.id}`">
          {{ row.name }}
        </router-link>
      </span>
      <span slot="members" slot-scope="{ row }">
        {{ row.staffs.length }}
      </span>
      <span slot="permissions" slot-scope="{ row }">
        {{ row.role ? row.role.permissions.length : 'Role is not settled' }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit work group')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/workgroups/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete work group')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import WorkGroupCollection from "@/collections/lab/WorkGroupCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

Vue.use(ServerTable);

export default {
  name: "PrepProcessServerTable",
  extends: BaseServerTable,
  components: {
    ModalTrashBasket,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new WorkGroupCollection(),
    },
    show_columns: {
      type: Array,
      default: () => [
        "name",
        "description",
        "members",
        "permissions",
        "actions",
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit work group") ||
      this.checkPermission("delete work group");

    return {
      entity_type: "workGroup",
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          headings: {
            members: "Members",
            permissions: "Permissions",
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "workGroupTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete work group") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    prepareCollectionFilter(filter) {
      filter.sortAddAsc("name");

      return filter;
    },
  },
};
</script>
